import React from "react";
import "./css/ExplorarHome.css";
import { Link } from "react-router-dom";

import grafico from "../../img/grafico.jpg";
import correos from "../../img/correos.png";
import ruleta from "../../img/ruleta.jpg";
import equipos from "../../img/equipos.jpg";
import diario from "../../img/diario.jpg";
import pesa from "../../img/pesa.jpg";
import comida from "../../img/comida.png";

const destacados = [
    { nombre: "Control de pesos", img: pesa, ruta: "/control-pesos" },
    { nombre: "Calculadora raciones", img: comida, ruta: "/calculadora-raciones" },
    { nombre: "Diario trading", img: diario, ruta: "/diario-trading" },
    { nombre: "Calculadora forex", img: grafico, ruta: "/calculadora-forex" },
    { nombre: "Programar correos", img: correos, ruta: "/correos" },
    { nombre: "Ruleta de Ganadores", img: ruleta, ruta: "/ganador-aleatorio" },
    { nombre: "Generar equipos", img: equipos, ruta: "/generar-equipos" },
];

const ExplorarHome = () => {
    return (
        <div className="explorar-home">
            <div className="explorar-header">
                <span className="explorar-icono" />
                <h4 className="explorar-title">Explorar más</h4>
            </div>

            <div className="explorar-scroll ps-1">
                {destacados.map((item, index) => (
                    <Link to={item.ruta} key={index} className="explorar-card">
                        <img src={item.img} alt={item.nombre} />
                        <p>{item.nombre}</p>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default ExplorarHome;
